module.exports = __webpack_public_path__ + "img/Teaching method.4dcecc33.png";